export default __webpack_public_path__ + "static/media/iconShield.dc0b42aa.svg";